import React, { useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ExpandableImage from '../ExpandableImage';
import { show, showMessages } from '@intercom/messenger-js-sdk';
interface ModalProps {
  showModal: boolean;
  handleModal: () => void;
  handleModalContact?: () => void;
  dataDemo?: any;
  img1?: string | null;
  img2?: string | null;
}
const DemoModal: React.FC<ModalProps> = ({ showModal, handleModal, dataDemo, handleModalContact, img1, img2 }) => {
  const benefitsArray = dataDemo.benefits ? dataDemo.benefits.split(',') : [];
  const offersArray = dataDemo.what_offers ? dataDemo.what_offers.split(',') : [];
  let imagen1 = dataDemo.previewImgUrl
  let imagen2 = dataDemo.thumbnailUrl
  const openLinkInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return (
    <Modal show={showModal} onHide={handleModal}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton className='me-3 align-items-start'>

        <Col md={8} className='px-2'>
          <strong>{dataDemo.parent_app_name}</strong>
          <p className='fs-14'>{dataDemo.description}</p>
        </Col>
        <Col md={4} className='px-2 d-flex flex-column px-4'>
          <p className='text-center' style={{ fontSize: 13 }}>
            To set up a demo, contact your account manager or customer success team
            {/* <a href="mailto:support@graydi.us">support@graydi.us</a> */}
          </p>
          <Button
            variant="primary"
            id="my_custom_link"
            className='bg-3 border-0 my-1 text-dark'
            onClick={() => show()}
            style={{ fontSize: 13 }}
          >
            Chat with a Gray DI team member.</Button>
          {/* <Button variant="light" className='my-1' onClick={() => openLinkInNewTab(dataDemo.demo_link)}>Try demo</Button> */}
        </Col>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={6} md={6} className='fs-14'>
            <strong >What it offers</strong>
            <ul>
              {(offersArray.length > 0) && offersArray.map((off: any) => (
                <li>{off}</li>
              ))}



            </ul>
          </Col>
          <Col xs={6} md={6} className="border-right fs-14" >
            <strong>Benefits</strong>
            <ul>
              {(benefitsArray.length > 0) && benefitsArray.map((off: any) => (
                <li>{off}</li>
              ))}

            </ul>
          </Col>
        </Row>
        <hr />
        <div className='d-flex justify-content-center'>
          {img1 ? (
            // Mostrar img2 si existe
            <ExpandableImage imageUrl={`${img1}`} />
          ) : imagen1 ? (
            // Mostrar imagen2 si img2 no existe pero imagen2 sí
            <ExpandableImage imageUrl={`${imagen1}`} />
          ) : (
            // Mostrar icondemo si ambas están vacías
            <Image src={require("../../Assets/demoimg.png")} thumbnail className='w-50' />
          )}
        </div>

      </Modal.Body>

    </Modal >
  )
}

export default DemoModal